import { BaseElement, html, css } from '../../base-element.js';

//components
import '@kerika/kerika-ui-components/components/kerika-markdown.js';
import '@kerika/kerika-ui-components/components/kerika-video.js';
import '../common/kerika-learn-more.js';
import '../common/kerika-tags.js';

const tagsValue = ['workManagement', 'projectManagement', 'taskManagement', 'taskBoards', 'kanbanBoards', 'exportingData', 'workItems'];
export class ExportingCardsPage extends BaseElement {
  static styles = [
    super.styles,
    css`
      :host {
        display: block;
        --kerika-image-width: 100%;
        --kerika-image-height: auto;
      }

      :host([layout='small']),
      :host([layout='medium']) {
        --min-width: 100%;
      }

      kerika-video {
        max-width: 1088px;
        margin: 16px 0;
      }

      h1 {
        color: var(--light-green-color);
        margin-bottom: 20px;
      }

      h4 {
        color: var(--mdc-theme-secondary);
        margin-bottom: 40px;
      }

      section {
        padding: 16px 0 24px 0;
      }

      section:nth-of-type(even) {
        background-color: var(--light-gray-color);
      }

      .one-click {
        --kerika-image-max-width: 540px;
        --kerika-image-padding: 16px 0 16px 24px;
      }

      :host([layout='small']) .one-click,
      :host([layout='medium']) .one-click {
        --kerika-image-max-width: 100%;
        --kerika-image-padding: 16px 0 8px 0;
      }

      .examples {
        --kerika-image-max-width: 1020px;
        --kerika-image-padding: 24px 0;
      }

      .mb-24 {
        margin-bottom: 24px;
      }

      .secondary-text {
        color: var(--mdc-theme-secondary);
      }

      .pb-16 {
        padding-bottom: 16px;
      }
    `,
  ];

  constructor() {
    super();
    this.i18nextNameSpaces = ['exporting-cards'];
  }

  render() {
    return html`
      <section class="hero-section horizontal layout center-justified">
        <div class="content layout vertical center">
          <h1 class="text-center">${this.t('exporting-cards:title')}</h1>
          <kerika-markdown class="secondary-text" value=${this.t('exporting-cards:subtitle')}></kerika-markdown>
          <kerika-video inline src="${this.t('exporting-cards:video')}"></kerika-video>
        </div>
      </section>

      <section class="horizontal layout center-justified one-click">
        <div class="content">
          <h4 class="text-center mb-24">${this.t('exporting-cards:oneClickAllItTakes.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:oneClickAllItTakes.description')}></kerika-markdown>
        </div>
      </section>

      <section class="horizontal layout center-justified">
        <div class="content">
          <h4 class="text-center">${this.t('exporting-cards:twoFormatsForexporting.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:twoFormatsForexporting.description')}></kerika-markdown>
        </div>
      </section>

      <section class="horizontal layout center-justified">
        <div class="content">
          <h4 class="text-center">${this.t('exporting-cards:whatYouGetWithAnExport.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:whatYouGetWithAnExport.description')}></kerika-markdown>
        </div>
      </section>

      <section class="horizontal layout center-justified examples pb-16">
        <div class="content">
          <h4 class="text-center">${this.t('exporting-cards:examples.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:examples.description')}></kerika-markdown>
        </div>
      </section>

      <section class="horizontal layout center-justified">
        <div class="content">
          <h4 class="text-center">${this.t('exporting-cards:yourExportedDate.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:yourExportedDate.description')}></kerika-markdown>
        </div>
      </section>

      <section class="horizontal layout center-justified">
        <div class="content">
          <h4 class="text-center">${this.t('exporting-cards:oneExportAtTime.title')}</h4>
          <kerika-markdown value=${this.t('exporting-cards:oneExportAtTime.description')}></kerika-markdown>
        </div>
      </section>

      <kerika-learn-more .request=${this.request} .features=${['TASKBOARDS_KANBAN', 'CANVASES', 'WIP_LIMIT']}></kerika-learn-more>

        <kerika-tags class="horizontal layout center-justified" .request=${this.request} i18nextPath="exporting-cards:tags" .value=${tagsValue}></kerika-tags>
    `;
  }
}
customElements.define('exporting-cards-page', ExportingCardsPage);
